import React from 'react';
import './ProductList.css';
import ProductCard from './ProductCard';

function ProductList({ productList }) {
  return (
    <ul className="products-list-container">
      {productList.map((item) => (
        <ProductCard key={item.id} props={item} />
      ))}
    </ul>
  );
}

export default ProductList;
